"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueuedFileUploader = void 0;
var queue = require("async/queue");
/**
 * @param {FileUploader} fileUploader
 * @param {number?} concurrency
 * @constructor
 */
var QueuedFileUploader = /** @class */ (function () {
    function QueuedFileUploader(fileUploader, concurrency) {
        if (concurrency === void 0) { concurrency = 4; }
        this.fileUploader = fileUploader;
        this.concurrency = concurrency;
        this.jobs = [];
        this.fileUploader = fileUploader;
        this.queue = queue(uploadWorker, concurrency);
        function uploadWorker(uploadJob, callback) {
            uploadJob.once('upload-end', callback);
            uploadJob.run(fileUploader);
        }
        this.jobs = [];
    }
    /**
     * @param {UploadJob} uploadJob
     * @returns {QueuedFileUploader}
     */
    QueuedFileUploader.prototype.enqueue = function (uploadJob) {
        var _this = this;
        if (this.jobs.indexOf(uploadJob) > -1) {
            console.warn('upload job already queued');
            return this;
        }
        this.jobs.push(uploadJob);
        this.queue.push(uploadJob, function () {
            var i = _this.jobs.indexOf(uploadJob);
            if (i > -1) {
                _this.jobs.splice(i, 1);
            }
        });
        return this;
    };
    /**
     * @description pauses the queue, in flight request will continue to completion
     * @returns {QueuedFileUploader}
     */
    QueuedFileUploader.prototype.pause = function () {
        this.queue.pause();
        return this;
    };
    /**
     * @description resume a paused queue
     * @returns {QueuedFileUploader}
     */
    QueuedFileUploader.prototype.resume = function () {
        this.queue.resume();
        return this;
    };
    /**
     * @description purges the queue, this will not abort in flight requests
     * @returns {QueuedFileUploader}
     */
    QueuedFileUploader.prototype.kill = function () {
        this.queue.kill();
        this.jobs = [];
        return this;
    };
    /**
     * @description the number of of jobs left in the queue
     * @returns {*}
     */
    QueuedFileUploader.prototype.length = function () {
        return this.queue.length();
    };
    return QueuedFileUploader;
}());
exports.QueuedFileUploader = QueuedFileUploader;
//# sourceMappingURL=queued-file-uploader.js.map